<template>
  <v-dialog v-model="dialog" max-width="1200">
    <template v-slot:activator="{ on }">
      <img :src="url" alt="image" v-on="on" class="viewer-image" />
    </template>

    <img :src="url" alt="image" class="dialog-image" />
  </v-dialog>
</template>

<script>
export default {
  props: ["url"],
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style lang="css">
.viewer-image {
  cursor: pointer;
  width: 100%;
}

.dialog-image {
  width: 100%;
}
</style>